import { createRestClientByModuleName } from "@/config/rest/restUtils";

const recruitingClient = createRestClientByModuleName("recruiting-system");

export const recruiting = {
  proposalsSend: (interviewId) =>
    recruitingClient.get(`/proposals/send/${interviewId}`)
};
